import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'
import * as variablesBuilder from '../../../../../variables-builder'

import * as generalTab from './general-tab'

@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    generalTab.Component,
    variablesBuilder.Component,
  ],
  selector: 'atn-mosaic-dev-page-dialog',
  standalone: true,
  styleUrls: ['./page.component.scss'],
  templateUrl: './page.component.html',
})
export class AtnPageDialogComponent {
  /** @see {@link state.mosaic.dev.pages.Collection} */
  public readonly pagesEc = ngCore.inject(state.mosaic.dev.pages.Collection)

  /** Title of the page dialog   */
  public readonly pageTitleSg = ngCore.computed(
    (
      isNew = this.pagesEc.plugins.currentEntityPlugin.feature.selectors
        .isCreating()
        .asSignal(),
    ) => {
      if (isNew) {
        return 'New Page'
      } else {
        // NOTE: not resolving in the arguments list, due to the fact that it
        // might not be needed to be resolved there.
        const page = this.pagesEc.plugins.currentEntityPlugin.feature.selectors
          .getEditedEntity()
          .asSignal()
        return page?.name ?? 'Edit Page'
      }
    },
  )

  /** TODO: */
  public saveClickHandler = () => {
    this.pagesEc.plugins.editingPlugin.feature.actions.submit
      .from('Dialog.SaveButton.Clicked')
      .dispatch({
        current: true,
      })
  }

  /** TODO: */
  public cancelClickHandler = () => {
    this.pagesEc.plugins.editingPlugin.feature.actions.discard
      .from('Dialog.CancelButton.Clicked')
      .dispatch({ current: true })
  }
}
